

'use client'

import React from "react";
import StaticBreadcrumbClient from "@/app/components/StaticBreadcrumbClient";

const timeline = [
    {
        name: 'Основание магазина «WGP Shop»',
        description:
            'Мы начали с простой идеи — сделать покупки удобными, честными и доступными по всей России.',
        date: 'Авг 2021',
        dateTime: '2021-08',
    },
    {
        name: 'Открыт первый склад',
        description:
            'Запустили быструю обработку заказов и улучшили логистику, чтобы доставлять ещё быстрее.',
        date: 'Дек 2021',
        dateTime: '2021-12',
    },
    {
        name: 'Запуск новой версии сайта',
        description:
            'Обновили каталог, фильтры и оформление заказа — теперь покупать ещё проще.',
        date: 'Фев 2022',
        dateTime: '2022-02',
    },
    {
        name: 'Доставляем по всей России',
        description:
            'Подключили новые службы доставки и пункты выдачи заказов в сотнях городов.',
        date: 'Дек 2022',
        dateTime: '2022-12',
    },
]
const jobOpenings = [
    {
        id: 1,
        role: 'Дизайнер (full‑time)',
        href: '#',
        description:
            'Ищем внимательного к деталям специалиста для работы с UI‑китами, баннерами и карточками товаров.',
        salary: 'от 150 000 ₽',
        location: 'Москва',
    },
    {
        id: 2,
        role: 'Laravel‑разработчик',
        href: '#',
        description:
            'Разработка и поддержка бэкенда, интеграции с платёжными и логистическими сервисами.',
        salary: 'от 220 000 ₽',
        location: 'Санкт‑Петербург / удалённо',
    },
    {
        id: 3,
        role: 'React Native‑разработчик',
        href: '#',
        description:
            'Создание мобильного приложения магазина «WGP Shop» для iOS и Android.',
        salary: 'от 200 000 ₽',
        location: 'Удалённо',
    },
]
//import { Container } from '@/components/Container'

/*export async function generateMetadata() {
    const metadata = await getData();
    return {
        title: metadata.SEO.BROWSER_TITLE || 'О компании',
        description: metadata.SEO.DESCRIPTION || 'О компании',
    };
}*/

export default function Home() {

    // Получаем HTML-контент
   /* const htmlContent = metadata.DETAIL_TEXT*/

    return (
        <div className="flex flex-col items-center justify-center">
            <div className="w-full max-w-[1536px] px-3 md:px-6">
                <div className="mb-4">
                    <StaticBreadcrumbClient pageTitle="О компании" />
                </div>
                <main className="isolate">
                    {/* Hero section */}
                    <div className="relative isolate -z-10 overflow-hidden bg-linear-to-b from-indigo-100/20 py-16 sm:py-24 dark:from-indigo-950/10">
                        <div className="">
                            <div className="mx-auto max-w-2xl lg:mx-0 lg:grid lg:max-w-none lg:grid-cols-2 lg:gap-x-16 lg:gap-y-8 xl:grid-cols-1 xl:grid-rows-1 xl:gap-x-8">
                                <h1 className="max-w-2xl text-5xl font-semibold tracking-tight text-balance text-gray-900 sm:text-7xl lg:col-span-2 xl:col-auto dark:text-white">
                                    Мы — команда «WGP Shop», создающая будущее онлайн‑торговли
                                </h1>
                                <div className="mt-6 max-w-xl lg:mt-0 xl:col-end-1 xl:row-start-1">
                                    <p className="text-lg font-medium text-pretty text-gray-500 sm:text-xl/8 dark:text-gray-400">
                                        Мы делаем покупки простыми и надёжными: честные цены, понятные условия доставки
                                        и внимательная поддержка. «WGP Shop» — это ваш удобный интернет‑магазин на каждый день.
                                    </p>
                                </div>
                                <img
                                    alt=""
                                    src="https://images.unsplash.com/photo-1567532900872-f4e906cbf06a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1280&q=80"
                                    className="mt-10 aspect-6/5 w-full max-w-lg rounded-2xl object-cover outline-1 -outline-offset-1 outline-black/5 sm:mt-16 lg:mt-0 lg:max-w-none xl:row-span-2 xl:row-end-2 xl:mt-36 dark:outline-white/10"
                                />
                            </div>
                        </div>
                        <div className="absolute inset-x-0 bottom-0 -z-10 h-24 bg-linear-to-t from-white sm:h-32 dark:from-gray-900" />
                    </div>

                    {/* Timeline section */}
                    <div className="py-16 sm:py-24">
                        <div className="mx-auto grid max-w-2xl grid-cols-1 gap-8 overflow-hidden lg:mx-0 lg:max-w-none lg:grid-cols-4">
                            {timeline.map((item) => (
                                <div key={item.name}>
                                    <time
                                        dateTime={item.dateTime}
                                        className="flex items-center text-sm/6 font-semibold text-indigo-600 dark:text-indigo-400"
                                    >
                                        <svg viewBox="0 0 4 4" aria-hidden="true" className="mr-4 size-1 flex-none">
                                            <circle r={2} cx={2} cy={2} fill="currentColor" />
                                        </svg>
                                        {item.date}
                                        <div
                                            aria-hidden="true"
                                            className="absolute -ml-2 h-px w-screen -translate-x-full bg-gray-900/10 sm:-ml-4 lg:static lg:-mr-6 lg:ml-8 lg:w-auto lg:flex-auto lg:translate-x-0 dark:bg-white/15"
                                        />
                                    </time>
                                    <p className="mt-6 text-lg/8 font-semibold tracking-tight text-gray-900 dark:text-white">{item.name}</p>
                                    <p className="mt-1 text-base/7 text-gray-600 dark:text-gray-400">{item.description}</p>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Logo cloud */}
                    <div className="">
                        <div className="relative isolate overflow-hidden bg-gray-900 px-6 py-16 text-center shadow-2xl sm:rounded-3xl sm:px-16 sm:py-24 dark:shadow-none dark:after:pointer-events-none dark:after:absolute dark:after:inset-0 dark:after:inset-ring dark:after:inset-ring-white/10 dark:after:sm:rounded-3xl">
                            <h2 className="mx-auto max-w-2xl text-3xl font-bold tracking-tight text-white sm:text-4xl">
                                Нас выбирают клиенты
                            </h2>
                            <p className="mx-auto mt-6 max-w-xl text-lg/8 text-gray-300">
                                Мы ценим доверие покупателей и каждый день улучшаем сервис,
                                чтобы заказывать в «WGP Shop» было приятно и просто.
                            </p>
                            <div className="mx-auto mt-20 grid max-w-lg grid-cols-4 items-center gap-x-8 gap-y-12 sm:max-w-xl sm:grid-cols-6 sm:gap-x-10 sm:gap-y-14 lg:max-w-4xl lg:grid-cols-5">
                                <img
                                    alt="Transistor"
                                    src="https://tailwindcss.com/plus-assets/img/logos/158x48/transistor-logo-white.svg"
                                    width={158}
                                    height={48}
                                    className="col-span-2 max-h-12 w-full object-contain lg:col-span-1"
                                />
                                <img
                                    alt="Reform"
                                    src="https://tailwindcss.com/plus-assets/img/logos/158x48/reform-logo-white.svg"
                                    width={158}
                                    height={48}
                                    className="col-span-2 max-h-12 w-full object-contain lg:col-span-1"
                                />
                                <img
                                    alt="Tuple"
                                    src="https://tailwindcss.com/plus-assets/img/logos/158x48/tuple-logo-white.svg"
                                    width={158}
                                    height={48}
                                    className="col-span-2 max-h-12 w-full object-contain lg:col-span-1"
                                />
                                <img
                                    alt="SavvyCal"
                                    src="https://tailwindcss.com/plus-assets/img/logos/158x48/savvycal-logo-white.svg"
                                    width={158}
                                    height={48}
                                    className="col-span-2 max-h-12 w-full object-contain sm:col-start-2 lg:col-span-1"
                                />
                                <img
                                    alt="Statamic"
                                    src="https://tailwindcss.com/plus-assets/img/logos/158x48/statamic-logo-white.svg"
                                    width={158}
                                    height={48}
                                    className="col-span-2 col-start-2 max-h-12 w-full object-contain sm:col-start-auto lg:col-span-1"
                                />
                            </div>
                            <div aria-hidden="true" className="absolute -top-24 right-0 -z-10 transform-gpu blur-3xl">
                                <div
                                    style={{
                                        clipPath:
                                            'polygon(73.6% 51.7%, 91.7% 11.8%, 100% 46.4%, 97.4% 82.2%, 92.5% 84.9%, 75.7% 64%, 55.3% 47.5%, 46.5% 49.4%, 45% 62.9%, 50.3% 87.2%, 21.3% 64.1%, 0.1% 100%, 5.4% 51.1%, 21.4% 63.9%, 58.9% 0.2%, 73.6% 51.7%)',
                                    }}
                                    className="aspect-1404/767 w-351 bg-linear-to-r from-[#80caff] to-[#4f46e5] opacity-25"
                                />
                            </div>
                        </div>
                    </div>

                    {/* CTA section */}
                    <div className="overflow-hidden py-16 sm:py-24">
                        <div className="">
                            <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-12 gap-y-16 lg:mx-0 lg:max-w-none lg:min-w-full lg:flex-none lg:gap-y-8">
                                <div className="lg:col-end-1 lg:w-full lg:max-w-lg lg:pb-8">
                                    <h2 className="text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl dark:text-white">
                                        Наша команда
                                    </h2>
                                    <p className="mt-6 text-xl/8 text-gray-700 dark:text-gray-300">
                                        Мы объединяем опытных специалистов в e‑commerce, чтобы создавать
                                        удобный и быстрый шопинг для миллионов пользователей.
                                    </p>
                                    <p className="mt-6 text-base/7 text-gray-600 dark:text-gray-400">
                                        Заботимся о каждом этапе: от подбора ассортимента и цен до доставки и поддержки.
                                    </p>
                                </div>
                                <div className="flex flex-wrap items-start justify-end gap-6 sm:gap-8 lg:contents">
                                    <div className="w-0 flex-auto lg:ml-auto lg:w-auto lg:flex-none lg:self-end">
                                        <img
                                            alt=""
                                            src="https://images.unsplash.com/photo-1670272502246-768d249768ca?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1152&q=80"
                                            className="aspect-7/5 w-148 max-w-none rounded-2xl bg-gray-50 object-cover max-sm:w-120 dark:bg-gray-800"
                                        />
                                    </div>
                                    <div className="contents lg:col-span-2 lg:col-end-2 lg:ml-auto lg:flex lg:w-148 lg:items-start lg:justify-end lg:gap-x-8">
                                        <div className="order-first flex w-64 flex-none justify-end self-end max-sm:w-40 lg:w-auto">
                                            <img
                                                alt=""
                                                src="https://images.unsplash.com/photo-1605656816944-971cd5c1407f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=768&h=604&q=80"
                                                className="aspect-4/3 w-[24rem] max-w-none flex-none rounded-2xl bg-gray-50 object-cover dark:bg-gray-800"
                                            />
                                        </div>
                                        <div className="flex w-96 flex-auto justify-end lg:w-auto lg:flex-none">
                                            <img
                                                alt=""
                                                src="https://images.unsplash.com/photo-1568992687947-868a62a9f521?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1152&h=842&q=80"
                                                className="aspect-7/5 w-148 max-w-none flex-none rounded-2xl bg-gray-50 object-cover max-sm:w-120 dark:bg-gray-800"
                                            />
                                        </div>
                                        <div className="hidden sm:block sm:w-0 sm:flex-auto lg:w-auto lg:flex-none">
                                            <img
                                                alt=""
                                                src="https://images.unsplash.com/photo-1612872087720-bb876e2e67d1?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=768&h=604&q=80"
                                                className="aspect-4/3 w-[24rem] max-w-none rounded-2xl bg-gray-50 object-cover dark:bg-gray-800"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Stats */}
                    <div className="py-16 sm:py-24">
                        <div className="">
                            <h2 className="text-4xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-5xl dark:text-white">
                                Мы работаем, чтобы делать покупки лучше каждый день
                            </h2>
                            <p className="mt-6 text-base/7 text-gray-600 dark:text-gray-300">
                                Ещё больше полезных товаров, прозрачные цены и удобная доставка — вот что для нас важно.
                            </p>
                        </div>
                        <div className="mx-auto mt-16 flex max-w-2xl flex-col gap-8 lg:mx-0 lg:mt-20 lg:max-w-none lg:flex-row lg:items-end">
                            <div className="flex flex-col-reverse justify-between gap-x-16 gap-y-8 rounded-2xl bg-gray-50 p-8 sm:w-3/4 sm:max-w-md sm:flex-row-reverse sm:items-end lg:w-72 lg:max-w-none lg:flex-none lg:flex-col lg:items-start dark:bg-white/5 dark:inset-ring dark:inset-ring-white/10">
                                <p className="flex-none text-3xl font-bold tracking-tight text-gray-900 dark:text-white">250k</p>
                                <div className="sm:w-80 sm:shrink lg:w-auto lg:flex-none">
                                    <p className="text-lg font-semibold tracking-tight text-gray-900 dark:text-white">
                                        Пользователей на платформе
                                    </p>
                                    <p className="mt-2 text-base/7 text-gray-600 dark:text-gray-300">
                                        Нам доверяют и рекомендуют друзьям и близким.
                                    </p>
                                </div>
                            </div>
                            <div className="flex flex-col-reverse justify-between gap-x-16 gap-y-8 rounded-2xl bg-gray-900 p-8 sm:flex-row-reverse sm:items-end lg:w-full lg:max-w-sm lg:flex-auto lg:flex-col lg:items-start lg:gap-y-44 dark:bg-gray-700 dark:inset-ring dark:inset-ring-white/10">
                                <p className="flex-none text-3xl font-bold tracking-tight text-white">8,9 млн ₽</p>
                                <div className="sm:w-80 sm:shrink lg:w-auto lg:flex-none">
                                    <p className="text-lg font-semibold tracking-tight text-white">
                                        Мы гордимся, что клиенты оформили заказов на сумму свыше 8,9 млн ₽.
                                    </p>
                                    <p className="mt-2 text-base/7 text-gray-400 dark:text-gray-300">
                                        Мы растём вместе с вами и продолжаем улучшать сервис.
                                    </p>
                                </div>
                            </div>
                            <div className="flex flex-col-reverse justify-between gap-x-16 gap-y-8 rounded-2xl bg-indigo-600 p-8 sm:w-11/12 sm:max-w-xl sm:flex-row-reverse sm:items-end lg:w-full lg:max-w-none lg:flex-auto lg:flex-col lg:items-start lg:gap-y-28 dark:inset-ring dark:inset-ring-white/10">
                                <p className="flex-none text-3xl font-bold tracking-tight text-white">401,093</p>
                                <div className="sm:w-80 sm:shrink lg:w-auto lg:flex-none">
                                    <p className="text-lg font-semibold tracking-tight text-white">Заказы в этом году</p>
                                    <p className="mt-2 text-base/7 text-indigo-200 dark:text-indigo-100">
                                        Мы ускорили доставку и расширили сеть пунктов выдачи.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Blog section */}
                    <div className="py-16 sm:py-24">
                        <div className="flex flex-col items-end justify-between gap-16 lg:mx-0 lg:max-w-none lg:flex-row">
                            <div className="w-full lg:max-w-lg lg:flex-auto">
                                <h2 className="text-3xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-4xl dark:text-white">
                                    Мы всегда рады талантливым людям в команде
                                </h2>
                                <p className="mt-6 text-xl/8 text-gray-600 dark:text-gray-400">
                                    Если вы разделяете наши ценности и хотите развивать e‑commerce, присоединяйтесь к «WGP Shop».
                                </p>
                                <img
                                    alt=""
                                    src="https://images.unsplash.com/photo-1606857521015-7f9fcf423740?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1344&h=1104&q=80"
                                    className="mt-16 aspect-6/5 w-full rounded-2xl object-cover outline-1 -outline-offset-1 outline-black/5 lg:aspect-auto lg:h-138 dark:outline-white/10"
                                />
                            </div>
                            <div className="w-full lg:max-w-xl lg:flex-auto">
                                <h3 className="sr-only">Открытые вакансии</h3>
                                <ul className="-my-8 divide-y divide-gray-100 dark:divide-gray-800">
                                    {jobOpenings.map((opening) => (
                                        <li key={opening.id} className="py-8">
                                            <dl className="relative flex flex-wrap gap-x-3">
                                                <dt className="sr-only">Роль</dt>
                                                <dd className="w-full flex-none text-lg font-semibold tracking-tight text-gray-900 dark:text-white">
                                                    <a href={opening.href}>
                                                        {opening.role}
                                                        <span aria-hidden="true" className="absolute inset-0" />
                                                    </a>
                                                </dd>
                                                <dt className="sr-only">Описание</dt>
                                                <dd className="mt-2 w-full flex-none text-base/7 text-gray-600 dark:text-gray-400">
                                                    {opening.description}
                                                </dd>
                                                <dt className="sr-only">Зарплата</dt>
                                                <dd className="mt-4 text-base/7 font-semibold text-gray-900 dark:text-white">{opening.salary}</dd>
                                                <dt className="sr-only">Город</dt>
                                                <dd className="mt-4 flex items-center gap-x-3 text-base/7 text-gray-500 dark:text-gray-400">
                                                    <svg
                                                        viewBox="0 0 2 2"
                                                        aria-hidden="true"
                                                        className="size-0.5 flex-none fill-gray-300 dark:fill-gray-600"
                                                    >
                                                        <circle r={1} cx={1} cy={1} />
                                                    </svg>
                                                    {opening.location}
                                                </dd>
                                            </dl>
                                        </li>
                                    ))}
                                </ul>
                                <div className="mt-8 flex border-t border-gray-100 pt-8 dark:border-gray-800">
                                    <a
                                        href="#"
                                        className="text-sm/6 font-semibold text-indigo-600 hover:text-indigo-500 dark:text-indigo-400 dark:hover:text-indigo-300"
                                    >
                                        Все вакансии <span aria-hidden="true">&rarr;</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
}
